module.exports = __webpack_public_path__ + "img/Dubai.c0d36b24.svg";